<div class="nlc-card">
  <div class="nlc-card-header">
    <div class="nlc-card-icon">
      <mat-icon>comment</mat-icon>
    </div>
    <div class="nlc-card-title-section">
      <h3>Kommentare</h3>
      <p>{{ (comments$ | async)?.length || 0 }} Kommentar(e)</p>
    </div>
  </div>
  <div class="nlc-card-content">
    <div *ngIf="loading$ | async" class="loading-state">
      <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
      <span>Lade Kommentare...</span>
    </div>
    <div *ngIf="(comments$ | async)?.length; else noComments" class="comments-list">
      <div *ngFor="let comment of (comments$ | async)" class="comment-item">
        <div class="comment-icon">
          <mat-icon>chat_bubble</mat-icon>
        </div>
        <div class="comment-content">
          <div
            *ngIf="comment && comment.customer && comment.customer.userDetails"
            class="comment-author"
          >
            <span class="author-name">
              {{ comment.customer.userDetails.firstName }}
              {{ comment.customer.userDetails.lastName }}
            </span>
          </div>
          <div class="comment-text" *ngIf="editingId !== comment.id; else editTpl">{{ comment.commentText }}</div>
          <ng-template #editTpl>
            <mat-form-field class="comment-edit-field" appearance="outline">
              <input matInput [(ngModel)]="editText" placeholder="Kommentar bearbeiten" />
            </mat-form-field>
            <div class="comment-edit-actions">
              <button mat-flat-button class="nlc-button nlc-button-primary" (click)="saveEdit(comment)">
                <mat-icon>save</mat-icon>
                <span>Speichern</span>
              </button>
              <button mat-stroked-button class="nlc-button" (click)="cancelEdit()">
                <span>Abbrechen</span>
              </button>
            </div>
          </ng-template>
          <div class="comment-date">
            {{ comment.changedDate | date : "dd.MM.yyyy HH:mm" }} Uhr
            <ng-container
              *ngIf="
                comment.createdDate &&
                comment.changedDate &&
                (comment.createdDate | date : 'yyyy-MM-ddTHH:mm:ss') !==
                  (comment.changedDate | date : 'yyyy-MM-ddTHH:mm:ss')
              "
            >
              <mat-icon
                class="edited-icon"
                matTooltip="Bearbeitet"
                >edit_note</mat-icon
              >
            </ng-container>
          </div>
        </div>
        <div class="comment-actions" *ngIf="!readOnly">
          <button
            mat-icon-button
            class="action-btn"
            (click)="startEdit(comment)"
            matTooltip="Bearbeiten"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            class="action-btn delete-btn"
            (click)="deleteComment(comment)"
            matTooltip="Löschen"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <ng-template #noComments>
      <div class="empty-state">
        <mat-icon>chat_bubble_outline</mat-icon>
        <p>Keine Kommentare vorhanden.</p>
      </div>
    </ng-template>
    <div class="add-comment-section" *ngIf="!readOnly">
      <mat-form-field appearance="outline" class="comment-input-field">
        <input
          matInput
          placeholder="Neuen Kommentar hinzufügen..."
          [(ngModel)]="newCommentText"
          (keyup.enter)="addComment(newCommentText); newCommentText = ''"
        />
        <mat-icon matPrefix>add_comment</mat-icon>
      </mat-form-field>
      <button
        mat-fab
        extended
        class="nlc-button nlc-button-primary"
        (click)="addComment(newCommentText); newCommentText = ''"
        [disabled]="!newCommentText.trim()"
        matTooltip="Kommentar hinzufügen"
      >
        <mat-icon>send</mat-icon>
        <span>Senden</span>
      </button>
    </div>
  </div>
</div>
